import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=e8577342&scoped=true"
import script from "./top-menu.vue?vue&type=script&lang=js"
export * from "./top-menu.vue?vue&type=script&lang=js"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=e8577342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8577342",
  null
  
)

export default component.exports